import React from 'react'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import './DataVisulization.css'
import brain from '../../assets/images/barchart.png'
import linechart from '../../assets/images/linechart.png'
import piechart from '../../assets/images/piechart.png'
import tablechart from '../../assets/images/tablechart.png'
import areachart from '../../assets/images/areachart.png'

function DataVisulization() {
    const capabilities = [
        { icon: "📝", text: "Add notes & version snapshots" },
        { icon: "📎", text: "Export to PDF, CSV, PNG" },
        { icon: "📈", text: "Track visual history" },
        { icon: "🔗", text: "Share view/edit links securely" },
        { icon: "📊", text: "Instant chart generation from chat answers" },
    ];

    const chartTypes = [
        { img: brain, label: "Bar" },
        { img: linechart, label: "Line" },
        { img: piechart, label: "Pie" },
        { img: tablechart, label: "Table" },
        { img: areachart, label: "Area" },
    ];
    return (
        <div className="home">
            <Header />
            <div className='banner-section d-flex flex-column align-items-center justify-content-center ' style={{ gap: '24px' }}>
                <h1 className="banner-title w-75">From Prompt to Plot in Seconds</h1>
                <p className="banner-description">
                    Brainyagent turns answers into charts, dashboards, and exports. Data visualization has never been this easy.
                </p>
                <div className='d-flex gap-3'>
                    <button className="theme-rounded-btn" style={{ padding: '16px 24px' }}>Build Your First Chart</button>
                    {/* <button className="theme-rounded-outline-btn" style={{ padding: '16px 24px' }}>Try On Sample Data</button> */}
                </div>
            </div>
            <div className='cards-section'>
                <h3>Chart Types You Can Build</h3>
                <div className='d-flex gap-24 w-100 card-container'>
                    {chartTypes.map((cap, i) => (
                        <div className='card-section'>
                            <div className='bg-white shadow w-100 rounded-5'><img src={cap.img} alt="" height={"100%"} width={"100%"} /></div>
                            <h5 className='w-100 text-center chart-section'>{cap.label}</h5>
                        </div>
                    ))}
                </div>
            </div>

            <div className="card-frame w-100 d-flex flex-column" style={{ padding: '64px 200px', gap: '48px' }}>
                <h3>Feature Highlights</h3>
                <h6 className=''>With Brainyagent, you can create a customized dashboard equipped with interactive charts based on your data. You can save these dashboards and share them with your team.</h6>
                <div className="capabilities-grid">
                    {capabilities.map((cap, i) => (
                        <div key={i} className="capability-card">
                            <span className="icon">{cap.icon}</span>
                            <span >{cap.text}</span>
                        </div>
                    ))}
                </div>
            </div>

            <div className='banner-section d-flex flex-column align-items-start justify-content-start ' style={{ gap: '24px', padding: '64px 200px' }}>
                <h1 className="banner-title text-start w-75" style={{fontSize:'45px'}}>Visualize your data, your way.</h1>
                <p className="banner-description text-start w-100">
                    Start with a question, turn it into insight, and share it beautifully.
                </p>
                <div className='d-flex gap-3'>
                    <button className="theme-rounded-btn" style={{ padding: '16px 24px' }}>Start Visualizing Data</button>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default DataVisulization